import React from 'react';
import MuiSwitch, {SwitchProps as MuiSwitchProps} from '@mui/material/Switch';
import {readOnlyContext} from 'common/context/ReadOnlyContext';
import {
   FormControlLabel as MuiFormControlLabel,
   FormControlLabelProps,
   Grid,
   Typography,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {TFunctionResult} from 'i18next';
import {useController, useFormContext} from 'react-hook-form';
import {useRegisterLabel} from 'common/context/FormContext';
import {IEnumItem} from 'common/enumType';
import {SetValueOptions} from 'components/hook-form/helpers';

const FormControlLabel = withStyles({
   label: {
      marginRight: '2rem',
   },
})(MuiFormControlLabel);

type Props = {
   label?: FormControlLabelProps['label'] | TFunctionResult;
   options: [IEnumItem, IEnumItem];
   name: string;
   disabled?: boolean;
   labelPlacement?: FormControlLabelProps['labelPlacement'];
   title?: string;
};

interface SwitchProps extends Props {
   value?: MuiSwitchProps['value'];
   checked: MuiSwitchProps['checked'];
   onChange: MuiSwitchProps['onChange'];
}
const Switch = ({
   name,
   disabled,
   options,
   labelPlacement = 'start',
   title,
   value,
   checked,
   onChange,
}: SwitchProps) => {
   const readOnly = React.useContext(readOnlyContext);

   return (
      <FormControlLabel
         label={''}
         labelPlacement={labelPlacement}
         disabled={disabled || readOnly}
         control={
            <Typography component="div">
               <Grid component="label" container alignItems="center" title={title} spacing={1}>
                  <Grid item>{options?.[0].name}</Grid>
                  <Grid item>
                     <MuiSwitch
                        disabled={disabled || readOnly}
                        name={name}
                        value={value}
                        checked={checked}
                        onChange={onChange}
                     />
                  </Grid>
                  <Grid item>{options?.[1].name}</Grid>
               </Grid>
            </Typography>
         }
      />
   );
};

const FormSwitchValueable = (props: Props) => {
   const {name, options, label} = props;
   const {
      field: {value},
   } = useController({name});
   useRegisterLabel(name, (label || name) as string);

   const {setValue} = useFormContext();

   const onChange = React.useCallback(
      (ev: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
         setValue(name, checked ? options[1].id : options[0].id, SetValueOptions);
      },
      [setValue, name, options]
   );

   return <Switch {...props} checked={value === options[1].id} onChange={onChange} />;
};

export default FormSwitchValueable;
